export default  {
    bindings: {
        offer: '<',
        formTab: '='
    },
    controller: 'offerPeriodFormController',
    template: require('../views/offer.period.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/components/offer.period.form.component.js